<script>
export default {
  props: {
    keys: {
      type: Array,
      required: true
    },

    items: {
      type: Array,
      default: () => []
    },

    omitKey: {
      type: Boolean,
      default: false
    },

    filteringDisabled: {
      type: Boolean,
      default: false
    },

    mapInsert: {
      type: Function,
      default: null
    },

    limit: {
      type: Number,
      default: 8
    }
  },

  data() {
    return {
      key: null,
      oldKey: null,
      searchText: null,
      caretPosition: null
    }
  },

  watch: {
    searchText(value, oldValue) {
      if (value) {
        this.$emit("search", value, oldValue)
      }
    }
  },

  mounted() {
    this.input = this.getInput()
    this.attach()
  },

  updated() {
    const input = this.getInput()
    if (input !== this.input) {
      this.detach()
      this.input = input
      this.attach()
    }
  },

  beforeDestroy() {
    this.detach()
  },

  methods: {
    getInput() {
      const [vnode] = this.$scopedSlots.default()
      if (vnode) {
        if (
          vnode.elm.tagName === "INPUT" ||
          vnode.elm.tagName === "TEXTAREA" ||
          vnode.elm.isContentEditable
        ) {
          return vnode.elm
        } else {
          return (
            vnode.elm.querySelector("input") ||
            vnode.elm.querySelector("textarea") ||
            vnode.elm.querySelector('[contenteditable="true"]')
          )
        }
      }
      return null
    },

    attach() {
      if (this.input) {
        this.input.addEventListener("input", this.onInput)
        this.input.addEventListener("keyup", this.onKeyUp)
      }
    },

    detach() {
      if (this.input) {
        this.input.removeEventListener("input", this.onInput)
        this.input.removeEventListener("keyup", this.onKeyUp)
      }
    },

    onInput() {
      this.checkKey()
    },

    onKeyUp(e) {
      if (
        this.cancelKeyUp &&
        (e.key === this.cancelKeyUp || e.keyCode === this.cancelKeyCode)
      ) {
        this.cancelEvent(e)
      }
      this.cancelKeyUp = null
    },

    cancelEvent(e) {
      e.preventDefault()
      e.stopPropagation()
      this.cancelKeyUp = e.key
    },

    getSelectionStart() {
      return this.input.isContentEditable
        ? window.getSelection().anchorOffset
        : this.input.selectionStart
    },

    getValue() {
      return this.input.isContentEditable
        ? window.getSelection().anchorNode.textContent
        : this.input.value
    },

    checkKey() {
      const index = this.getSelectionStart()
      if (index >= 0) {
        const { key, keyIndex } = this.getLastKeyBeforeCaret(index)
        const searchText = (this.lastSearchText = this.getLastSearchText(
          index,
          keyIndex
        ))

        if (!(keyIndex < 1 || /\s/.test(this.getValue()[keyIndex - 1]))) {
          return false
        }

        if (searchText != null) {
          this.openMenu(key, keyIndex)
          this.searchText = searchText
          return true
        }
      }
      this.closeMenu()
      return false
    },

    getLastKeyBeforeCaret(caretIndex) {
      const [keyData] = this.keys
        .map(key => ({
          key,
          keyIndex: this.getValue().lastIndexOf(key, caretIndex - 1)
        }))
        .sort((a, b) => b.keyIndex - a.keyIndex)
      return keyData
    },

    getLastSearchText(caretIndex, keyIndex) {
      if (keyIndex !== -1) {
        const searchText = this.getValue().substring(keyIndex + 1, caretIndex)
        // If there is a space we close the menu
        if (!/\s/.test(searchText)) {
          return searchText
        }
      }
      return null
    },

    openMenu(key, keyIndex) {
      if (this.key !== key) {
        this.key = key
        this.keyIndex = keyIndex
        this.$emit("open", key)
      }
    },

    closeMenu() {
      if (this.key != null) {
        this.oldKey = this.key
        this.key = null
        this.$emit("close", this.oldKey)
      }
    }
  }
}
</script>

<template>
  <div class="w-100">
    <slot />
  </div>
</template>
